import { useDatabaseUser } from '@components/FirebaseAuthentication';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Typography, Box } from '@mui/material';

export default function UserInfo() {
    const databaseUser = useDatabaseUser();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <AccountCircleIcon sx={{ marginRight: '1rem' }} color="primary" fontSize="small" />
            <Typography
                sx={{
                    fontSize: '.8rem',
                }}
            >
                {databaseUser?.email || ''}
            </Typography>
        </Box>
    );
}
